module.exports = __webpack_public_path__ + "static/media/dog-paw.30199f6b.svg";